import * as React from 'react';
import * as d3 from 'd3';
export class d3BoxPlot {
    svg_id: string;
    loading_id: string;

    width: number;
    height: number;

    //in_state_pct: any;
    //all_others: any;
    //bench_year: any;

    constructor(svg_id, loading_id, width, height
        //    , in_state_pct, all_others, bench_year
    ) {
        this.svg_id = svg_id;
        this.loading_id = loading_id;

        this.width = width;
        this.height = height;

        //this.in_state_pct = in_state_pct;
        //this.all_others = all_others;
        //this.bench_year = bench_year;
    }

    drawChart(in_state_pct, all_others, bench_year, the_university) {
        var loading = document.getElementById(this.loading_id);
        loading.style.display = "none";

        var width = this.width;
        var height = this.height;
        var barWidth = 30;

        var margin = { top: 20, right: 10, bottom: 40, left: 40 };

        var width = width - margin.left - margin.right,
            height = height - margin.top - margin.bottom;

        var totalWidth = width + margin.left + margin.right;
        var totalheight = height + margin.top + margin.bottom;

        var temp = all_others.map(x => +(x.in_state * 100).toFixed(0));//[];//{};
        //var globalCounts = all_others.map(x => x.in_state.toFixed(2) * 100);//[];
        var groupCounts = temp.sort(sortNumber);

        var in_state = +(in_state_pct * 100).toFixed(0);
        
        // Setup a color scale for filling each box
        var colorScale = d3.scaleOrdinal();

        // Prepare the data for the box plots
        var boxPlotData = [];
        // for (var [key, groupCount] of Object.entries(groupCounts)) {
        var key = "FY " + bench_year;
        var groupCount = groupCounts;
        var record = {};
        var localMin = d3.min(groupCount);
        var localMax = d3.max(groupCount);

        record["key"] = key;
        record["counts"] = groupCount;
        record["quartile"] = boxQuartiles(groupCount);
        record["whiskers"] = [localMin, localMax];
        record["color"] = colorScale(key);

        boxPlotData.push(record);

        var xScale = d3.scalePoint()
            .domain([key])
            .rangeRound([0, width])
            .padding([0.5]);

        // Compute a global y scale based on the global counts
        var min = 0;//d3.min(groupCounts);
        var max = Math.max(Math.min(100,d3.max(groupCounts)+15),in_state);
        var yScale = d3.scaleLinear()
            .domain([max, min])
            .range([0, height]);

        // Setup the svg and group we will draw the box plot in
        var svg = d3.select("#" + this.svg_id)
                .attr("width", totalWidth)
            .attr("height", totalheight)

        svg.selectAll("*").remove();

        var the_g = svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        var legend = the_g.append("g")
            .attr("class", "legend_box")

        legend.append("rect")
            .attr("stroke", "black")
            .attr("fill", "none")
            .attr("x", width - 4.4 * the_university.length - 90)
            .attr("y", -20)
            .attr("width", 35 + 4.4 * the_university.length)
            .attr("height", 20)
            .attr("transform", "translate(" + (the_university.length-58)*1.6 +", 0)")

        legend.append("circle")
            .attr("cx", width - 4.4 * the_university.length - 80)
            .attr("cy", -10)
            .attr("r", 5)
            .style("fill", "red")
            .attr("transform", "translate(" + (the_university.length - 58) * 1.6 + ", 0)")

        legend.append("text")
            .attr("x", width - 4.4 * the_university.length - 70)
            .attr("y", -7)
            .text(the_university)
            .attr("font-size", "10px")
            .attr("transform", "translate(" + (the_university.length - 58) * 1.6 + ", 0)")

        // Move the left axis over 25 pixels, and the top axis over 35 pixels
        var axisG = the_g.append("g").attr("transform", "translate(25,15)");
        var axisBottomG = the_g.append("g").attr("transform", "translate(25," + (this.height - margin.bottom - 5) + ")");

        // Setup the group the box plot elements will render in
        var g = the_g.append("g")
            .attr("transform", "translate(10,15)");

        // Draw the box plot vertical lines
        var verticalLines = g.selectAll(".verticalLines")
            .data(boxPlotData)
            .enter()
            .append("line")
            .attr("x1", function (datum) {
                            return xScale(datum.key) + barWidth / 2;
                        }
            )
            .attr("y1", function (datum) {
                            var whisker = datum.whiskers[0];
                            return yScale(whisker);
                        }
            )
            .attr("x2", function (datum) {
                            return xScale(datum.key) + barWidth / 2;
                        }
            )
            .attr("y2", function (datum) {
                            var whisker = datum.whiskers[1];
                            return yScale(whisker);
                        }
            )
            .attr("stroke", "#000")
            .attr("stroke-width", 1)
            .attr("fill", "none");

        // Draw the boxes of the box plot, filled in white and on top of vertical lines
        var rects = g.selectAll("rect")
            .data(boxPlotData)
            .enter()
            .append("rect")
            .attr("width", barWidth)
            .attr("height", function (datum) {
                var quartiles = datum.quartile;
                var height = yScale(quartiles[0]) - yScale(quartiles[2]);
                return height;
            }
            )
            .attr("x", function (datum) {
                return xScale(datum.key);
            }
            )
            .attr("y", function (datum) {
                return yScale(datum.quartile[2]);
            }
            )
            .attr("fill", function (datum) {
                return datum.color;
            }
            )
            .attr("stroke", "#000")
            .attr("stroke-width", 1);



        // Now render all the horizontal lines at once - the whiskers and the median
        var horizontalLineConfigs = [
            // Top whisker
            {
                x1: function (datum) { return xScale(datum.key) },
                y1: function (datum) { return yScale(datum.whiskers[0]) },
                x2: function (datum) { return xScale(datum.key) + barWidth },
                y2: function (datum) { return yScale(datum.whiskers[0]) },

                // for text
                x: function (datum) { return xScale(datum.key) + 40 },
                y: function (datum) { return yScale(datum.whiskers[0]) },
                text: function (datum) { return datum.whiskers[0]+"%" }
            },
            // Median line
            {
                x1: function (datum) { return xScale(datum.key) },
                y1: function (datum) { return yScale(datum.quartile[1]) },
                x2: function (datum) { return xScale(datum.key) + barWidth },
                y2: function (datum) { return yScale(datum.quartile[1]) },

                x: function (datum) { return xScale(datum.key) + 40 },
                y: function (datum) { return yScale(datum.quartile[1]) },
                text: function (datum) { return datum.quartile[1] + "%" }
            },
            // Bottom whisker
            {
                x1: function (datum) { return xScale(datum.key) },
                y1: function (datum) { return yScale(datum.whiskers[1]) },
                x2: function (datum) { return xScale(datum.key) + barWidth },
                y2: function (datum) { return yScale(datum.whiskers[1]) },

                x: function (datum) { return xScale(datum.key) + 40 },
                y: function (datum) { return yScale(datum.whiskers[1]) },
                text: function (datum) { return datum.whiskers[1] + "%" }
            },

            // Upper quartile
            {
                //unused x1,x2,y1,y2
                x1: function (datum) { return xScale(datum.key) },
                y1: function (datum) { return yScale(datum.whiskers[1]) },
                x2: function (datum) { return xScale(datum.key) + barWidth },
                y2: function (datum) { return yScale(datum.whiskers[1]) },

                x: function (datum) { return xScale(datum.key) - 60 },
                y: function (datum) { return yScale(datum.quartile[0]-3) },
                text: function (datum) { return datum.quartile[0] + "%" }
            },
            // Lower quartile
            {
                //unused x1,x2,y1,y2
                x1: function (datum) { return xScale(datum.key) },
                y1: function (datum) { return yScale(datum.whiskers[1]) },
                x2: function (datum) { return xScale(datum.key) + barWidth },
                y2: function (datum) { return yScale(datum.whiskers[1]) },

                x: function (datum) { return xScale(datum.key) - 60 },
                y: function (datum) { return yScale(datum.quartile[2]-1) },
                text: function (datum) { return datum.quartile[2] + "%" }
            }
        ];
        var less_than_3 = 0;
        for (var i = 0; i < horizontalLineConfigs.length; i++) {
            var lineConfig = horizontalLineConfigs[i];

            if (less_than_3 < 3) {
            // Draw the whiskers at the min for this series
            var horizontalLine = g.selectAll(".whiskers")
                .data(boxPlotData)
                .enter()
                .append("line")
                .attr("x1", lineConfig.x1)
                .attr("y1", lineConfig.y1)
                .attr("x2", lineConfig.x2)
                .attr("y2", lineConfig.y2)
                .attr("stroke", "#000")
                .attr("stroke-width", 1)
                    .attr("fill", "none");
            }
            less_than_3++;
            g.selectAll(".labels")
                .data(boxPlotData)
                .enter()
                .append("text")
                .attr("x", lineConfig.x)
                .attr("y", lineConfig.y)
                .text(lineConfig.text);
        }
        // Setup a scale on the left
        var axisLeft = d3.axisLeft(yScale)
            .tickFormat(d => d + "%")
            .tickSize(2)

        axisG.append("g")
            .call(axisLeft);

        the_g.append("text")
            .attr("text-anchor", "middle")
            .attr("transform", "translate(-10," + (height / 2) + ")rotate(-90)")
            .text("percentage of in-state expenditure")
            .attr("font-size", "13px");

        // Setup a series axis on the top
        var axisBottom = d3.axisBottom(xScale);
        axisBottomG.append("g")
            .call(axisBottom);

        //draw university dot
        the_g.append("circle")
            .attr("transform", "translate(25,15)")
            .attr("cx", xScale(key))
            .attr("cy", yScale(in_state))
            .attr("r", 5)
            .style("fill", "red")

        function boxQuartiles(d) {
            return [
                d3.quantile(d, .25),
                d3.quantile(d, .5),
                d3.quantile(d, .75)
            ];
        }

        // Perform a numeric sort on an array
        function sortNumber(a, b) {
            return a - b;
        }

    }
}